import axios from 'axios';
import {api} from '../../constants/api';
import {errors as E} from 'common/constants/errors';

export const getRows = (
  url,
  shumaId,
  requestedPageNumber,
  sortBy,
  sortDirection
) => {
  const data = {
    shumaID: shumaId ? parseInt(shumaId, 10) : 0,
    requestedPageNumber: requestedPageNumber ? parseInt(requestedPageNumber, 10) : 0,
    sortBy,
    sortDirection
  };

  return axios.post(url, data)
    .then((response) => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body
    })
    .catch((err) => {
      console.error(err)
    });
};

export const getRowsTaxAuthority = async (
  shumaId,
  requestedPageNumber,
  sortBy,
  sortDirection
) => {
  return await getRows(
    api.GET_SAVED_ROWS_TAX_AUTHORITY,
    shumaId,
    requestedPageNumber,
    sortBy,
    sortDirection
  )
};

export const getRowsFirm = async (
  shumaId,
  requestedPageNumber,
  sortBy,
  sortDirection
) => {
  return await getRows(
    api.GET_SAVED_ROWS_FIRM,
    shumaId,
    requestedPageNumber,
    sortBy,
    sortDirection
  )
};

export const getRowsShared = async (
  shumaId,
  requestedPageNumber,
  sortBy,
  sortDirection
) => {
  return await getRows(
    api.GET_SAVED_ROWS_SHARED,
    shumaId,
    requestedPageNumber,
    sortBy,
    sortDirection
  )
};

export const getRowsSurveyAssets = async (
  shumaId,
  requestedPageNumber,
  sortBy,
  sortDirection
) => {
  return await getRows(
    api.GET_SAVED_ROWS_SURVEY_ASSETS,
    shumaId,
    requestedPageNumber,
    sortBy,
    sortDirection
  )
};

export const getRowsForExcel = (
  url,
  shumaId,
  sortBy,
  sortDirection
) => {
  const data = {
    shumaID: shumaId ? parseInt(shumaId, 10) : 0,
    sortBy,
    sortDirection
  };

  return axios.post(url, data)
    .then((response) => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body
    })
    .catch((err) => {
      console.error(err)
    });
};

export const getRowsTaxAuthorityForExcel = async (shumaId, sortBy, sortDirection) => {
  return await getRowsForExcel(api.GET_SAVED_ROWS_FOR_EXCEL_TAX_AUTHORITY, shumaId, sortBy, sortDirection)
};

export const getRowsFirmForExcel = async (shumaId, sortBy, sortDirection) => {
  return await getRowsForExcel(api.GET_SAVED_ROWS_FOR_EXCEL_FIRM, shumaId, sortBy, sortDirection)
};

export const getRowsSharedForExcel = async (shumaId, sortBy, sortDirection) => {
  return await getRowsForExcel(api.GET_SAVED_ROWS_FOR_EXCEL_SHARED, shumaId, sortBy, sortDirection)
};

export const getRowsSurveyAssetsForExcel = async (shumaId, sortBy, sortDirection) => {
  return await getRowsForExcel(api.GET_SAVED_ROWS_FOR_EXCEL_SURVEY_ASSETS, shumaId, sortBy, sortDirection)
};

export const removeRow = (url, shumaId, id) => {
  const data = {
    shumaID: shumaId ? parseInt(shumaId, 10) : 0,
    id
  };

  return axios.post(url, data)
    .then((response) => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body
    })
    .catch((err) => {
      console.error(err)
    });
};

export const removeRowTaxAuthority = async (shumaId, id) => {
  return await removeRow(api.REMOVE_ROW_TAX_AUTHORITY, shumaId, id)
};

export const removeRowFirm = async (shumaId, id) => {
  return await removeRow(api.REMOVE_ROW_FIRM, shumaId, id)
};

export const removeRowShared = async (shumaId, id) => {
  return await removeRow(api.REMOVE_ROW_SHARED, shumaId, id)
};

export const removeRowSurveyAssets = async (shumaId, id) => {
  return await removeRow(api.REMOVE_ROW_SURVEY_ASSETS, shumaId, id)
};

export const getOriginalRow = (url, shumaId, id) => {
  const data = {
    shumaID: shumaId ? parseInt(shumaId, 10) : 0,
    id: id ? parseInt(id, 10) : 0
  };

  return axios.post(url, data)
    .then((response) => {
      const {errorCode, body} = response.data;
      if (errorCode < 0) throw new Error(E.SERVER_ERROR);

      return body
    })
    .catch((err) => {
      console.error(err)
    });
};

export const getOriginalRowTaxAuthority = async (shumaId, id) => {
  return await getOriginalRow(api.GET_ORIGINAL_ROW_TAX_AUTHORITY, shumaId, id)
};

export const getOriginalRowFirm = async (shumaId, id) => {
  return await getOriginalRow(api.GET_ORIGINAL_ROW_FIRM, shumaId, id)
};

export const getOriginalRowShared = async (shumaId, id) => {
  return await getOriginalRow(api.GET_ORIGINAL_ROW_SHARED, shumaId, id)
};

export const getOriginalRowSurveyAssets = async (shumaId, id) => {
  return await removeRow(api.GET_ORIGINAL_ROW_SURVEY_ASSETS, shumaId, id)
};

export const editRow = (url, shumaId, values) => {
  const data = {
    shumaID: shumaId ? parseInt(shumaId, 10) : 0,
    ...values
  };

  return axios.post(url, data)
};

export const editRowTaxAuthority = async (shumaId, values) => {
  return await editRow(api.EDIT_ROW_TAX_AUTHORITY, shumaId, values)
};

export const editRowFirm = async (shumaId, values) => {
  return await editRow(api.EDIT_ROW_FIRM, shumaId, values)
};

export const editRowShared = async (shumaId, values) => {
  return await editRow(api.EDIT_ROW_SHARED, shumaId, values)
};

export const editRowSurveyAssets = async (shumaId, values) => {
  return await editRow(api.EDIT_ROW_SURVEY_ASSETS, shumaId, values)
};
